export interface AssetSequenceDurationInput {
  kind?: string | null;
  directUrl?: string | null;
  declaredDurationSeconds?: number | null;
  decodedVideoDurationSeconds?: number | null;
  maxDurationSeconds?: number | null;
}

export function resolveAssetSequenceDurationSeconds(input: AssetSequenceDurationInput): number {
  const maxDuration = positiveNumber(input.maxDurationSeconds) ?? Number.POSITIVE_INFINITY;
  const isVideo = isAssetSequenceVideoSource(input.kind, input.directUrl);
  const decodedVideoDuration = roundedPositive(input.decodedVideoDurationSeconds);
  if (isVideo && decodedVideoDuration !== null) {
    return clampDuration(decodedVideoDuration, maxDuration);
  }

  const declaredDuration = roundedPositive(input.declaredDurationSeconds);
  if (declaredDuration !== null) {
    return clampDuration(declaredDuration, maxDuration);
  }

  return isVideo ? 5 : 10;
}

export function isAssetSequenceVideoKind(kind: string | null | undefined): boolean {
  return (kind || '').toLowerCase().includes('video');
}

export function isAssetSequenceVideoSource(kind: string | null | undefined, directUrl: string | null | undefined): boolean {
  if (isAssetSequenceVideoKind(kind)) return true;
  const url = (directUrl || '').toLowerCase().split('?')[0];
  return /\.(mp4|webm|mov|m4v)$/.test(url);
}

function roundedPositive(value: number | null | undefined): number | null {
  const parsed = positiveNumber(value);
  return parsed === null ? null : Math.round(parsed * 10) / 10;
}

function positiveNumber(value: number | null | undefined): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function clampDuration(value: number, maxDuration: number): number {
  const bounded = Math.min(maxDuration, Math.max(0.1, value));
  return Math.round(bounded * 10) / 10;
}
